import React from 'react';
import { Link } from 'react-router-dom';
import ShopLayout from '../components/shop/ShopLayout';
import { useCart } from '../context/CartContext';
import { formatPrice } from '../utils/shopHelpers';
import './CartPage.css';
import Seo from '../components/seo/Seo';

function CartPage() {
  const { items, cartCount, subtotal, updateQuantity, removeItem, clearCart } = useCart();

  return (
    <ShopLayout breadcrumbs={[{ label: 'Cart' }]}>
      <Seo title="Shopping Cart" path="/cart" />
      <div className="container cart-page">
        <h1 className="cart-page__title">Shopping Cart ({cartCount})</h1>

        {items.length === 0 ? (
          <div className="cart-page__empty">
            <p>Your cart is empty.</p>
            <Link to="/shop" className="cart-page__continue">Continue Shopping</Link>
          </div>
        ) : (
          <div className="cart-page__layout">
            <div className="cart-page__items">
              {items.map((item) => (
                <div key={item.productId} className="cart-page__item">
                  <img src={item.image} alt={item.name} className="cart-page__item-image" />
                  <div className="cart-page__item-info">
                    <h3>{item.name}</h3>
                    <p className="cart-page__item-sku">SKU: {item.sku}</p>
                    <p className="cart-page__item-price">{formatPrice(item.price)}</p>
                  </div>
                  <div className="cart-page__item-qty">
                    <label htmlFor={`cart-qty-${item.productId}`}>Qty</label>
                    <input
                      id={`cart-qty-${item.productId}`}
                      type="number"
                      min="1"
                      value={item.quantity}
                      onChange={(e) => updateQuantity(item.productId, Number(e.target.value))}
                    />
                  </div>
                  <p className="cart-page__item-total">
                    {formatPrice(item.price * item.quantity)}
                  </p>
                  <button
                    type="button"
                    className="cart-page__remove"
                    onClick={() => removeItem(item.productId)}
                    aria-label="Remove item"
                  >
                    ✕
                  </button>
                </div>
              ))}
              <button type="button" className="cart-page__clear" onClick={clearCart}>
                Clear Cart
              </button>
            </div>

            <aside className="cart-page__summary">
              <h2>Order Summary</h2>
              <div className="cart-page__summary-row">
                <span>Subtotal</span>
                <span>{formatPrice(subtotal)}</span>
              </div>
              <div className="cart-page__summary-row cart-page__summary-row--muted">
                <span>Shipping</span>
                <span>Calculated at checkout</span>
              </div>
              <div className="cart-page__summary-row cart-page__summary-row--muted">
                <span>Tax</span>
                <span>Calculated at checkout</span>
              </div>
              <div className="cart-page__summary-row cart-page__summary-total">
                <span>Estimated Total</span>
                <span>{formatPrice(subtotal)}</span>
              </div>
              <Link to="/checkout" className="cart-page__checkout">
                Proceed to Checkout
              </Link>
              <Link to="/shop" className="cart-page__continue-link">Continue Shopping</Link>
            </aside>
          </div>
        )}
      </div>
    </ShopLayout>
  );
}

export default CartPage;
